
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Tabs } from "antd";
import { LeftCircleFilled } from "@ant-design/icons";
import SceneApi from "../../../../api/SceneApi";
import ViewStateService from "../../../../services/view-state/ViewStateService";
import { SceneDetailsWrapper, SceneNameTitle, GoBackText, GoBackWrapper, TitleBar } from "./SceneDetails.styled";
import SceneInformation from "./components/scene-information/SceneInformation";
import SceneDevices from "./components/scene-devices/SceneDevices";

interface SceneDetailsProps {
    onClose: ()=> void,
    onComplete: ()=> void
}

const SceneDetails: React.FC<SceneDetailsProps> = (props)=> {
    // api
    let navigate = useNavigate();
    let location = useLocation();
    let viewStateService = ViewStateService.getInstance();
    let sceneApi = new SceneApi();

    // parameters
    let {sceneId} = useParams();
    let [searchParams] = useSearchParams();
    let defaultTabKey = searchParams.get('tab') || 'device-information';

    // state
    let [sceneView, setSceneView] = useState(null);

    // events
    let loadScene = async ()=> {
        if(!sceneId) {
            return;
        }

        let sceneView = (await sceneApi.getSceneViewById(sceneId)).data.data;
        setSceneView(sceneView);
    }

    let onGoBack = ()=> {
        if(location.key=='default') {
            navigate("/scene-management");
        } else {
            navigate(-1);
        }
    }
    
    useEffect(()=> {
        // set status bar title
        viewStateService.setStatusBarTitle('场景详情');

        // load scene information according to scene id parameter
        loadScene();

    }, []);
    
    // render
    let tabItems = [
        {
            key: 'scene-information',
            label: '场景信息',
            children: sceneView && <SceneInformation sceneView={sceneView} />
        },
        {
            key: 'scene-devices',
            label: '场景设备',
            children: sceneView && <SceneDevices sceneView={sceneView} />
        },
        /*{
            key: 'scene-variables',
            label: '场景变量',
            children: sceneView && <SceneVariables sceneView={sceneView} />
        }*/
    ];

    return (
        <SceneDetailsWrapper>
            <TitleBar>
                <GoBackWrapper onClick={onGoBack}>
                    <LeftCircleFilled style={{fontSize: '20px'}} />
                    <GoBackText>返回</GoBackText>
                </GoBackWrapper>
                <SceneNameTitle>{sceneView?.scene.name}</SceneNameTitle>
            </TitleBar>
    
            { sceneView && 
                <Tabs
                    defaultActiveKey={defaultTabKey}
                    items={tabItems}
                    style={{flex: '1 1 auto', overflow: 'hidden'}}
                />
            }
        </SceneDetailsWrapper>
    )
}

export default SceneDetails;

